import React, { MouseEvent } from 'react';

interface HomeIconProps {
  className?: string;
  onClick?: (event: MouseEvent) => void;
}

const HomeIcon = ({ className, onClick }: HomeIconProps) => {
  return (
    <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
      <g clipPath="url(#clip0_2213_7290)">
        <path d="M8.50033 4.53042L12.042 7.71792V13.25H10.6253V9H6.37533V13.25H4.95866V7.71792L8.50033 4.53042ZM8.50033 2.625L1.41699 9H3.54199V14.6667H7.79199V10.4167H9.20866V14.6667H13.4587V9H15.5837L8.50033 2.625Z" fill="#191B1E"/>
      </g>
      <defs>
        <clipPath id="clip0_2213_7290">
          <rect width="17" height="17" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default HomeIcon;